import { Injectable } from '@angular/core';
import {
  CanDeactivate,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { UploadDocumentService } from '../_services/upload-document.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ExitPageGuard implements CanDeactivate<ComponentCanDeactivate> {
  constructor(private uploadDocumentService: UploadDocumentService) { }
  canDeactivate(
    component: ComponentCanDeactivate
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return component.canDeactivate() ? true : this.triggerExitPageModal();
  }

  triggerExitPageModal() {
    this.uploadDocumentService.setPageExitModal(true);
    return this.uploadDocumentService.getPageExitConfirm().pipe(
      map((confirm) => {
        return confirm;
      })
    );
  }
}

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}
